export default __webpack_public_path__ + "static/media/BuyplanFavoriteStoresSettings.30fe3b9b.png";